export abstract class ProductManagement {

}